import { useTranslation } from "@localization/useTranslation";
import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import DotLegalDocumentUploadWrapper from "@common/components/DotLegalDocumentUploadWrapper";
import { useProcessDocumentPane } from "./ProcessDocumentPane.hooks";
import { ProcessDocument } from "../ProcessDocument.types";
import { definePane } from "../../../../main/panes/definePane";
import PaneLayout from "../../../../main/panes/paneLayout/PaneLayout";
import UploadProgressBar from "@common/components/uploadProgress/UploadProgressBar";

export interface IProcessDocumentPaneProps {
    processId: string;
    selectedDocument?: ProcessDocument;
}

function ProcessDocumentPane(props: IProcessDocumentPaneProps) {
    const { translateString } = useTranslation();
    const { document, save, validation, isEdit, modelUpdater, showUpload, isSaving, documentUploadModel, isUploading, uploadPercentage } =
        useProcessDocumentPane(props);

    validation.check(document);

    return (
        <PaneLayout
            header={isEdit ? translateString("editDocument") : translateString("uploadDocument")}
            okButtonText={isEdit ? translateString("save") : translateString("upload")}
            onOkClick={() => save()}
            inProgress={isSaving}
        >
            <Grid size={{ md: 12 }}>
                <DotLegalTextField
                    label={translateString("name")}
                    value={document.name ?? ""}
                    debounce={false}
                    errorText={validation.getErrorsForDisplay("name")}
                    onChange={modelUpdater.onNameChange}
                />
            </Grid>
            <Box mt={2} mb={2}>
                {showUpload && (
                    <DotLegalDocumentUploadWrapper
                        showError={validation.showErrors}
                        viewModel={documentUploadModel}
                        onDataChange={modelUpdater.onDocumentUploadModelChange}
                        isEdit={isEdit}
                    />
                )}
                <UploadProgressBar isUploading={isUploading} uploadPercentage={uploadPercentage} />
            </Box>
        </PaneLayout>
    );
}

export default definePane({ slot: "right", component: ProcessDocumentPane });
